export default "__VITE_ASSET__517bf488__"